export default "__VITE_ASSET__BNrG3TEa__"